/* less/lib/less/data/index */ function _(require, module, exports) {
    module.exports = {
        colors: require(170) /* ./colors */,
        unitConversions: require(172) /* ./unit-conversions */
    };
}
